import React from 'react';
import { createUseStyles } from 'react-jss';

import { ZINDEX } from '../../constants';
import Locker from './locker';
import Progress from './progress';

const useStyles = createUseStyles({
  loader: {
    background: 'rgba(0, 0, 0, 0)',
    color: '#FFFFFF',
    composes: ['is-overlay'],
    zIndex: ZINDEX.LOADER_SPINNER,
  },
  logo: {
    composes: ['is-absolute'],
    left: '50%',
    marginLeft: -25,
    marginTop: -25,
    top: '50%',
    width: 50,
  },
});

const LoaderComponent = function LoaderComponent() {
  const classes = useStyles();
  return (
    <div className={classes.loader}>
      <Locker />
      <Progress />
    </div>
  );
};

LoaderComponent.displayName = 'LoaderComponent';

export default LoaderComponent;
